import { SchematronValideringsFejlDto, VisualModelNode } from '@models';

import { EformsConstants } from '@/main/constants/eforms-constants';
import { ChoiceGroupLookup } from '@/main/models/eforms/choiceGroupLookup';
import { eformsDataUtil } from '@/main/utils/eforms-data-util';

/**
 * Metode til at bestemme om fejl skal frasorteres. Fejlen frasorteres, hvis choiceGroup er valgt,
 * således at feltet bag fejlen ikke vises. Metoden undersøger kun en dybde af choiceGroup (dvs. ikke nested radioknapper).
 * Dette virker kun for phantom nodes, da der specifikt kigges i internal choice
 * @param fejl fejlen som vi ønsker at afgøre om skal frasorteres
 * @param choiceGroupLookupHelper Record af choiceGroupLookupHelper, så felts tilhørende choiceGroup kan findes hurtigt
 * @param visualModel visualModelNode, hvori choice group kan findes
 */
export function skalFejlFiltreres(
  fejl: SchematronValideringsFejlDto,
  choiceGroupLookupHelper: Record<string, ChoiceGroupLookup> | undefined,
  visualModel: VisualModelNode
): boolean {
  if (fejl?.contentId && choiceGroupLookupHelper && fejl.contentId in choiceGroupLookupHelper) {
    const lookup: ChoiceGroupLookup = choiceGroupLookupHelper[fejl.contentId];
    const choiceGroupId: string = EformsConstants.ChoiceNodes.LEAF + lookup.choiceGroupId;
    const choiceGroup: VisualModelNode | undefined = eformsDataUtil.findInModel(visualModel.children!, choiceGroupId);
    if (choiceGroup && choiceGroup.value !== '' && choiceGroup.value !== lookup.parentId) {
      return true;
    }
  }
  return false;
}
